const breakpoints = {
  values: {
    xs: 0,
    sm: 768,
    md: 1024, // OLD 960
    lg: 1440, // OLD 1280
    xl: 1536 // OLD 1920
  }
};

export default breakpoints;
